import React, { useEffect } from "react";
import "./DeleteConfirmModal.css";

/**
 * Minimal & Professional Reusable Delete Confirmation Modal
 * Icon-Free, Crisp Typography & Theme Aligned
 */
const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete Record",
  message = "Are you sure you want to delete this record? This action cannot be undone.",
  itemName = "",
  loading = false,
  confirmText = "Delete",
  cancelText = "Cancel",
}) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      if (e.key === "Escape" && !loading) {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, loading, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="custom-delete-modal-overlay"
      onClick={() => {
        if (!loading) onClose();
      }}
    >
      <div
        className="custom-delete-modal-container"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-modal-title"
      >
        {/* Header */}
        <div className="custom-delete-modal-header">
          <h3 id="delete-modal-title" className="custom-delete-modal-title">
            {title}
          </h3>
          <button
            type="button"
            className="custom-delete-modal-close"
            onClick={onClose}
            disabled={loading}
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        {/* Content */}
        <div className="custom-delete-modal-body">
          <p className="custom-delete-modal-message">
            {itemName ? (
              <>
                Are you sure you want to delete{" "}
                <span className="item-highlight">{itemName}</span>? This action cannot be undone.
              </>
            ) : (
              message
            )}
          </p>
        </div>

        {/* Actions */}
        <div className="custom-delete-modal-actions">
          <button
            type="button"
            className="custom-delete-modal-btn-cancel"
            onClick={onClose}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className="custom-delete-modal-btn-confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? "Deleting..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
